import { render, staticRenderFns } from "./ListRecords.vue?vue&type=template&id=0057c3af&scoped=true&"
import script from "./ListRecords.vue?vue&type=script&lang=js&"
export * from "./ListRecords.vue?vue&type=script&lang=js&"
import style0 from "./ListRecords.vue?vue&type=style&index=0&id=0057c3af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0057c3af",
  null
  
)

export default component.exports